import { useEffect, useState } from 'react';
import { SEARCH_MIN_CHARS } from '../../pages/EditTopology/configuration/constants';
import { filterItems } from '../../pages/EditTopology/configuration/searchUtils';

interface UseSearchFilterProps<T extends Record<string, unknown>> {
  filterKeys: string[];
  items: T[];
}

interface UseSearchFilter<T extends Record<string, unknown>> {
  filteredItems: T[];
  handleSearchChange: (value: string) => void;
  searchValue: string;
}

export function useSearchFilter<T extends Record<string, unknown>>({
  filterKeys,
  items,
}: UseSearchFilterProps<T>): UseSearchFilter<T> {
  const [filteredItems, setFilteredItems] = useState<T[]>(items);
  const [searchValue, setSearchValue] = useState<string>('');

  useEffect(() => {
    if (searchValue.length === 0) {
      setFilteredItems(items);
    } else if (searchValue.length >= SEARCH_MIN_CHARS) {
      const searchText = searchValue.toLowerCase();
      const result = filterItems({
        filterKeys,
        list: items,
        searchText,
      });
      setFilteredItems(result);
    }
  }, [items, searchValue, filterKeys]);

  function handleSearchChange(newSearchValue: string): void {
    setSearchValue(newSearchValue);
  }

  return { filteredItems, handleSearchChange, searchValue };
}
